var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.998,
    height: 22.047,
    viewBox: "0 0 21.998 22.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1.248 -1.248)",
    opacity: 0.501
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20861",
    "data-name": "Path 20861",
    d: "M20.622,8.67a9.315,9.315,0,0,1,.507,1.822.77.77,0,0,0,.758.639.808.808,0,0,0,.13-.011.769.769,0,0,0,.629-.888,11.067,11.067,0,0,0-.589-2.119.77.77,0,0,0-1.435.559Z",
    transform: "translate(0.489 0.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20862",
    "data-name": "Path 20862",
    d: "M17.275,4.421a.758.758,0,0,0,.433.134.769.769,0,0,0,.434-1.4A11,11,0,0,0,16.214,2.1a.769.769,0,1,0-.6,1.412,9.672,9.672,0,0,1,1.662.907Z",
    transform: "translate(0.351 0.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20863",
    "data-name": "Path 20863",
    d: "M19.743,4.515a.769.769,0,1,0-1.1,1.071,9.52,9.52,0,0,1,1.178,1.483.769.769,0,1,0,1.294-.833A11.092,11.092,0,0,0,19.743,4.515Z",
    transform: "translate(0.435 0.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20864",
    "data-name": "Path 20864",
    d: "M14.459,1.467a11.023,11.023,0,1,0,8.784,11.906.769.769,0,0,0-1.53-.152A9.484,9.484,0,1,1,12.272,2.788a9.614,9.614,0,0,1,1.885.188.862.862,0,0,0,.152.014.769.769,0,0,0,.151-1.523Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20865",
    "data-name": "Path 20865",
    d: "M4,12.2A8.2,8.2,0,1,0,12.2,4,8.2,8.2,0,0,0,4,12.2Zm8.972-5.127v4.737l3.794,2.85a.769.769,0,0,1-.923,1.23l-4.1-3.076a.758.758,0,0,1-.308-.615V7.076a.769.769,0,0,1,1.538,0Z",
    transform: "translate(0.07 0.07)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.01c60de62171fbd5edbbb82bce81b619.svg";
export { ForwardRef as ReactComponent };